export default __webpack_public_path__ + "static/media/Curve-Loading.5e01ee79.gif";